import { CarsState } from "./state.js";
import { applyCarsFilters } from "./filters.js";

export function initCarsClear() {
  const dom = CarsState.dom;
  if (!dom || !dom.clearBtn) return;

  dom.clearBtn.addEventListener("click", function () {
    dom.brandChecks.forEach((ch) => (ch.checked = false));
    if (dom.searchInput) dom.searchInput.value = "";
    applyCarsFilters();
  });
}